<template>
	<div class="p-2">
		<b-button v-if="data.length > 0" class="is-primary" :disabled="isSubmitDisabled" @click="$emit('save')">
			Speichern
		</b-button>
	</div>
</template>

<script>
export default {
	name: "StockUpSave",
	props: ["selectedAccount", "selectedBalance", "data", "columns"],
	computed: {
		isSubmitDisabled() {
			if (!this.selectedAccount || !this.selectedBalance) return true;

			// Prüfe, ob in IRGENDEINER Zeile die 'entity' fehlt
			const hasEmptyEntity = this.data.some(row => {
				return row.entity === undefined || row.entity === null || row.entity === '';
			});

			// Prüfe die Spalten (dein idx === 0 skip ist okay, wenn die erste Spalte die Instanz ist)
			const hasEmptyColumn = this.columns.some((c, idx) => {
				if (idx === 0) return false;
				return c.value === undefined || c.value === null;
			});

			return hasEmptyEntity || hasEmptyColumn;
		}
	}
}
</script>

<style scoped></style>